/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLazyQuery, useQuery } from '@apollo/client';
import Image from 'next/image';
import notesBgSVG from '../home/icons/notesbg.svg';
import ViewAllButton from '../home/course-section/ViewAllButton';
import NoDataFound from './NoDataFound';
import HorizontalScroll from './HorizontalScroll';
import BreadCrumb from '../home/header/BreadCrumb';
import { GET_DATA_BY_LIST_ID } from './HomeQueryList';
import Spinner from './spinner';
import { useFirebase } from '../../contexts/ssr-firebase-context';
import Get_Signed_Url_By_ContentId from '../../gql/queries/get-signed-url-by-contentId.gql';

const defaultSelectData = 1;
function NotesCard({
  sectionTitle, data, entityID, page, pageType = '1', allBatchID,
}) {
  const pageUrl = `view-all/${entityID}`;
  const [notesData] = useState(data?.contents, entityID);
  const [notesDataAll, setNotesDataAll] = useState();
  const [currentOption, setCurrentOption] = useState(defaultSelectData);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('All');
  const [currentListId, setCurrentListId] = useState('');
  const [isDataFilter, setIsDataFilter] = useState(false);
  const [allPersistData, setAllPersistData] = useState();
  const { getConfigValue } = useFirebase();

  let homePageData;
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'UAT') {
    homePageData = getConfigValue('web_home_uat') || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'BETA') {
    homePageData = getConfigValue('web_home_beta') || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD') {
    homePageData = getConfigValue('web_home_prod') || [];
  }

  const subjectId = homePageData?.subjectId;

  const { data: subjectData, loading: subjecTLoading } = useQuery(GET_DATA_BY_LIST_ID, {
    variables: {
      listId: subjectId,
    },
  });
  const { data: onFilterData, loading: onFilterLoading } = useQuery(GET_DATA_BY_LIST_ID, {
    variables: {
      listId: currentListId,
    },
    skip: !currentListId,
  });

  const handleChangeFilter = (id) => {
    setCurrentListId(id);
    setIsDataFilter(true);
  };

  useEffect(() => {
    setNotesDataAll(data);
  }, [data]);

  useEffect(() => {
    setAllPersistData(data);
  }, [data]);

  useEffect(() => {
    setNotesDataAll(onFilterData?.getListContents?.contents);
  }, [onFilterData]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const [getSignedUrlByContentId] = useLazyQuery(Get_Signed_Url_By_ContentId);

  const handleNotesClick = async (id) => {
    try {
      const { data: pdfResponse } = await getSignedUrlByContentId({
        variables: {
          contentId: id,
          type: 'pdf',
        },
      });
      if (pdfResponse?.getSignedUrlByContentId?.signedUrl) {
        window.open(pdfResponse?.getSignedUrlByContentId?.signedUrl, '_blank');
      }
      console.log('pdfResponse', pdfResponse);
    } catch (err) {
      console.error('Error fetching handout:', err);
    }
  };
  const handleOptionClick = (e) => {
    const option = e.target.dataset.idValue;
    setSelectedOption(e.target.title);
    setCurrentOption(option);
    setIsOpen(false);
    if (e.target.title === 'All') {
      setNotesDataAll(allPersistData);
    } else {
      handleChangeFilter(option);
    }
  };

  if (subjecTLoading || onFilterLoading) {
    return <div><Spinner fullPage /></div>;
  }

  const dropDown = () => (
    <div className="relative w-full lg:w-64">
      {/* Dropdown Trigger */}
      <button
        onClick={toggleDropdown}
        type="button"
        className="flex items-center justify-between w-full px-4 py-3 bg-white border border-thinBlue rounded-lg shadow-sm"
      >
        <div className="flex">
          {/* Location Icon */}
          {/* <Image width={500} height={500} src={MapSvg} className="text-blue-500 mr-2" alt="mapicons" /> */}
          <span className="text-gray-700 line-clamp-1 text-left">{selectedOption}</span>
        </div>
        {/* Dropdown Arrow */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-5 w-5 text-gray-500 transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <ul className="absolute z-10 mt-2 w-full bg-white border border-blueThinDobule rounded-lg shadow-md max-h-60 overflow-auto border-b-[4px] border-b-[#00C3FF]">
          <li
            title="All"
            key={allBatchID}
            type="button"
            onClick={handleOptionClick}
            data-id-value={allBatchID}
              // onChange={handleOptionClick(item.id)}
            className={`px-4 py-2 m-2 cursor-pointer hover:bg-blue-50 border-b ${currentOption === allBatchID
              ? 'bg-lightThinBlue text-customBlue font-semibold'
              : 'text-gray-700'}`}
          >
            All
          </li>
          {subjectData && subjectData?.getListContents?.contents.map((item) => (
            <li
              title={item.name}
              key={item.id}
              onClick={handleOptionClick}
              data-id-value={item.id}
              className={`px-4 py-2 m-2 cursor-pointer hover:bg-blue-50 border-b ${currentOption === item.id
                ? 'bg-lightThinBlue text-customBlue font-semibold'
                : 'text-gray-700'}`}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
  // viwe all list page html;
  if (pageType === '2' && data) {
    return (
      <div className="p-4">
        <BreadCrumb type={2} />
        <div className="flex justify-between mb-5 lg:mb-[34px] items-center">
          <div className="hidden lg:block xl:text-2xl text-lg font-semibold" />
          <div className="lg:flex lg:gap-3 justify-center lg:justify-end items-center w-full">
            <h4 className="hidden lg:block">Select Subject: </h4>
            {dropDown()}
          </div>
        </div>
        {selectedOption && selectedOption !== 'Select'
          ? (
            <div className="flex items-center pb-5 lg:hidden">
              <div className="flex-grow border-t border-gray-300" />
              <span className="px-4 text-gray-500">{selectedOption}</span>
              <div className="flex-grow border-t border-gray-300" />
            </div>
          )
          : ''}

        <div className="text-xs font-medium lg:font-semibold lg:text-base">
          <div className="flex gap-6 flex-wrap">
            { notesDataAll?.length > 0 ? (
              notesDataAll.map((item) => (
                <div className="border border-blue-200 rounded-lg lg:pb-3 w-full lg:w-[23%] bg-white" key={item?.id}>
                  <div onClick={() => handleNotesClick(item?.contentId)} className="flex justify-start items-center lg:block">
                    <div className="flex relative ">
                      <Image width={500} height={500} src={notesBgSVG} alt="teacher-banner" className="self-start p-1 rounded-tl-lg rounded-tr-lg" />
                    </div>
                    <span className="w-full h-full block lg:pt-3 px-2 text-sm font-medium line-ellipsis-two">
                      {' '}
                      {item?.name}
                      {' '}
                    </span>
                  </div>
                </div>

              ))) : (
                <div className="flex justify-center items-center w-full min-h-80">
                  <NoDataFound noMsg="No Notes match your selected subject. Please try adjusting your subject." />
                </div>
            )}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="flex justify-between mb-[18px] lg:mb-[34px] items-center pr-5 lg:pr-0">
        <div className="xl:text-2xl text-lg font-semibold">{sectionTitle}</div>
        <ViewAllButton pageType="notes" pageUrl={pageUrl} queryString="" typeButton={2} hiddenLgBTn={false} pageTitle={page} />
      </div>

      <HorizontalScroll className="scrollbar-hide">
        <ul className="flex flex-shrink-0 gap-4 text-xs font-medium lg:font-semibold lg:text-base">
          { notesData?.length > 0 ? (
            notesData.map((item) => (
              <li className="border border-blue-200 rounded-lg lg:p-2 pb-3 w-[160px] lg:w-[322px] flex-shrink-0 bg-white" key={item?.url}>
                <div onClick={() => handleNotesClick(item?.contentId)} className="flex justify-start items-center lg:block cursor-pointer">
                  <div className="flex relative ">
                    <Image width={500} height={500} src={notesBgSVG} alt="teacher-banner" className="self-start w-80" />
                  </div>
                  <span className="h-100 block pt-3 px-2 font-medium line-ellipsis-two">
                    {' '}
                    {item?.name}
                  </span>
                </div>
              </li>
            ))) : (
              <li className="flex justify-center items-center w-full bg-white min-h-80">
                <NoDataFound noMsg="No Notes found" />
              </li>
          )}
        </ul>
      </HorizontalScroll>

    </div>
  );
}
NotesCard.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  data: PropTypes.any.isRequired,
  entityID: PropTypes.any,
  page: PropTypes.any,
  pageType: PropTypes.any,
  allBatchID: PropTypes.any,
};

export default NotesCard;
